export default {
  // landing
  startBrowsing: '開始瀏覽',
  whyArcLight: '為什麼選擇 ArcLight',
  developedBy: '開發團隊',
  forProject: '為',
  developedApp: '計劃而開發',
  // about
  why: '為什麼選擇',
  about: '關於',
  arcLightLocalized: 'ArcLight (弧光)',
  about1P1Part1: 'Project ArcLight（弧光計劃）最初是以 Arweave 平台的存儲系統來設計和構建的，在',
  about1P1Part2: ' 公布之後，我們把目光放在了打造一個真正開放和自由的音樂分發平台來完成這個 GitCoin Bounty 所需的要求。',
  about1P2Part1: '為什麼選擇 ArcLight？我們使用Arweave 的永存網作為我們的儲存空間來存放你的精美作品，我們盡全力去保護你對你作品的版權所有信息，這當然就包括把你的音樂作品加密為在開放的區塊鏈瀏覽器中無法被直接解碼的數據，這樣一來，用戶必須支付你所指定的價格來獲取下載信息，當然你也可以設置試聽時長來防止音樂錄製盜用。',
  allDifferent: '所有你能想到的',
  sound: '聲音',
  weSupport: '我們支持',
  singleMusic: '單曲音樂',
  albums: '專輯發布',
  podcasts: '播客電台',
  andWithComma: '，以及',
  soundEffects: '音效',
  about2P1Part1: '我們支持各種類型的作品可供你上傳，就如同標題內容所述，你可以上傳單曲、專輯、播客、音效到ArcLight 平台上，有了強大的知識庫，您可以使用多達913 種不同類型的音樂和專輯的流派類別，並且播客的類別與Apple Podcast 類別完全一致。',
  about2P1Part2: '發揮你所有的創造力，創作你能想到的任何東西，ArcLight 能幫你把它們都儲存起來。',
  encryption: '加密',
  andWithSpace: ' 和 ',
  profit: '收益',
  secureWay: '安全的策略',
  toStoreYourArtworks: '來儲存和共享你的作品',
  about3P1Part1: '一次不錯的機會來介紹我們的技術是如何來確保您的藝術品安全的',
  about3P2Part1: '與 DRM 系統不同的是，我們只是在您上傳到瀏覽器內部後對您的音頻進行簡單的加密，經過我們自己的加密後，Arweave API 會再次加密後再上傳到 Permaweb（永存網）。您的聽眾只有在向您付費後才能獲得源文件，否則只能獲得少量的音樂試聽或完整的試用版（如果您想關閉試聽功能）。客戶決定為你的作品付費後，會使用官方代幣 AR 支付到你的賬戶。',
  // header
  music: '音樂',
  login: '登入',
  uploadYourKey: '提供你的私鑰',
  insertYourKey: '選擇你的私鑰文件',
  saveYourKeyInCookie: '7 日內使用保存的私鑰自動登入',
  accountHasNoBalance: '帳戶余額為零，請使用另一個帳戶再試一次',
  accountHasErroredTx: '你的賬戶存在錯誤的交易，請檢查你的余額再試一次',
  uploadMusic: '上傳音樂',
  searchPlaceholder: '搜索 地址 / 用戶 / 音樂',
  // account menu
  myProfile: '個人主頁',
  myLibrary: '我的音樂庫',
  signOut: '登出',
  // file message
  fileReadSuccess: '文件讀取成功',
  fileReadFail: '文件讀取失敗，請再試一次',
  imageReadSuccess: '圖片讀取成功',
  // page title
  mainTitle: '去中心化音樂平台',
  uploadNewSingle: '上傳新單曲',
  uploadNewAlbum: '上傳新專輯',
  uploadNewPodcast: '上傳新播客',
  uploadNewSoundEffect: '上傳新音效',
  reviewYourUpload: '檢查你的上傳信息',
  browseAllAlbum: '所有專輯',
  browseAllSingle: '所有單曲',
  browseAllMusic: '所有曲目',
  profile: '個人主頁',
  profileOf: '的個人主頁',
  // general
  cacheLogin: '本地登入',
  cacheUpload: '本地保存',
  upload: '上傳',
  close: '關閉',
  search: '搜索',
  noData: '無數據',
  single: '單曲',
  album: '專輯',
  podcast: '播客',
  soundEffect: '音效',
  loading: '載入中...',
  artistLoading: '作曲者信息正在載入...',
  genre: '音樂流派',
  category: '類別',
  price: '價格',
  review: '檢查上傳表單',
  verify: '驗證上傳文件',
  transaction: '交易',
  confirm: '確認',
  submit: '提交',
  done: '完成',
  // songs
  newSingleSelling: '最新發布單曲',
  allSelling: '所有單曲',
  newAlbumSelling: '最新發布專輯',
  newPodcastSelling: '最新發布播客',
  newSoundEffectSelling: '最新發布音效',
  // profile
  similarAuthors: '相似作曲家',
  editProfile: '編輯個人主頁',
  // upload
  chooseType: '選擇你想要上傳的類型',
  backToSelection: '返回選擇菜單',
  singleCover: '單曲封面',
  albumCover: '專輯封面',
  podcastCover: '播客封面',
  soundEffectCover: '音效封面',
  musicName: '單曲名稱',
  podcastTitle: '播客名稱 (如需更新到舊的播客請使用同一個名稱)',
  programTitle: '節目名稱',
  soundEffectName: '音效名稱',
  enterYourMusicTitle: '請輸入你的單曲名稱...',
  enterYourAlbumTitle: '請輸入你的專輯名稱...',
  enterYourPodcastTitle: '請輸入你的播客名稱...',
  enterYourProgramTitle: '請輸入你的節目名稱...',
  enterYourSoundEffectTitle: '請輸入你的音效名稱...',
  uploadDescription: '簡介 (使用 \\n 進行換行)',
  yourSingleDescription: '請輸入你的單曲簡介...',
  yourAlbumDescritption: '請輸入你的專輯簡介...',
  yourPodcastDescription: '請輸入你的節目簡介...',
  yourSoundEffectDescription: '請輸入你的音效簡介...',
  selectYourFile: '選擇你的文件',
  demoDuration: '試聽長度',
  pleaseUploadYourArtwork: '請上傳你的作品...',
  loginIsRequiredToUpload: '必須登入才可上傳作品',
  usernameIsRequiredToUpload: '必須設置用戶名才可上傳作品',
  selectDemoDuration: '選擇試聽長度',
  genreIsRequiredToUpload: '請選擇你的作品所屬的音樂流派 (None 表示留空)',
  demoDurationIsRequiredToUpload: '請選擇試聽長度',
  priceMustBeNumber: '價格必須為數字',
  priceCantBeNegative: `價格不可以為負值`,
  demoCantBeSetToFreeMusic: `免費音樂不可設置試聽時長`,
  // single
  singleCoverIsRequiredToUpload: '需要設置封面才可發布單曲',
  singleTitleIsRequiredToUpload: '需要設置標題才可發布单曲',
  singleDespIsRequiredToUpload: '需要設置簡介才可發布单曲',
  singleSourceFileIsRequiredToUpload: '需要選中上傳文件才可發布单曲',
  // album
  albumCoverIsRequiredToUpload: '需要設置封面才可發布專輯',
  albumTitleIsRequiredToUpload: '需要設置標題才可發布專輯',
  albumDespIsRequiredToUpload: '需要設置簡介才可發布專輯',
  albumPleaseUploadAtLeast: '請上傳至少 ',
  albumPleaseUploadAtLeastFile: ' 個文件',
  albumSongShouldHavePriceOrFree: '專輯內單曲僅可每曲單獨設置價格或完全免費',
  albumSourceFileIsRequiredToUpload: '專輯內缺失應有的曲目源文件',
  albumMusicTitleIsRequiredToUpload: '音樂必須具有標題給 #',
  albumPriceWillAlwaysBe80Percent: '專輯總價格將永遠為你所有單曲總價的 80%',
  // podcast
  podcastCoverIsRequiredToUpload: '需要設置封面才可發布播客',
  podcastTitleIsRequiredToUpload: '需要設置播客標題才可發布播客',
  podcastProgramTitleIsRequiredToUpload: '需要設置節目名稱才可發布播客',
  podcastDespIsRequiredToUpload: '需要設置簡介才可發布播客',
  podcastCategoryIsRequiredToUpload: '請為你的播客節目選擇類別 (None 表示留空)',
  podcastSourceFileIsRequiredToUpload: '需要選中上傳文件才可發布播客',
  // sound Effect
  soundEffectCoverIsRequiredToUpload: '需要設置封面才可發布音效',
  soundEffectTitleIsRequiredToUpload: '需要設置標題才可發布音效',
  soundEffectDespIsRequiredToUpload: '需要設置簡介才可發布音效',
  soundEffectSourceFileIsRequiredToUpload: '需要選中上傳文件才可發布音效',
  // review
  backToUpload: '返回上傳表單',
  singleWarning: '請在此仔細檢查你的單曲上傳內容，',
  albumWarning: '請在此仔細檢查你的專輯上傳內容，',
  podcastWarning: '請在此仔細檢查你的播客上傳內容，',
  soundEffectWarning: '請在此仔細檢查你的音效上傳內容，',
  reviewWarning: '如果無任何問題，你就可以提交你的上傳請求了',
  priceCost: '價格消耗',
  uploadingCover: '正在上傳封面...',
  uploadingMusic: '正在上傳曲目...',
  uploadSuccess: '上傳成功！',
  uploadPending: '上傳正在等待確認',
  uploadPendingInfo: '你的作品已提交至 Arweave Permaweb Storage（永存網存儲中心）。你的作品在上傳結束之後可能不會立即可用，數據需要區塊鏈上的礦工進行數據處理後幫你存儲至下一個區塊。請耐心等待，你的作品將會被永遠存儲起來！',
  unknownErrorOccurred: '發生了未知錯誤'
}



// WEBPACK FOOTER //
// ./src/locales/zh-tw.js